import { styled } from 'styled-components';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa6';
import Link from 'next/link';
import { BREAKPOINT_SP } from '@/util/const';
type PagingButtonProps = {
  status?: 'active' | 'disabled' | 'normal'; // active:クリックできる、normal:現在のページ
  number?: number;
  size?: 'large' | 'small';
  onClick?: () => void;
  type: 'left' | 'number' | 'right' | 'next' | 'prev';
  url?: string;
  className?: string;
};
export default function PagingButton(props: PagingButtonProps) {
  let url = '/';
  if (props.url != undefined) {
    url = props.url;
  }

  const isDisabled = props.status === 'disabled'; // disabled状態を定義

  function getButton() {
    switch (props.type) {
      case 'next':
        return isDisabled ? (
          <NextWrapper className={props.className} disabled={true}>
            次<FaAngleRight />
          </NextWrapper>
        ) : (
          <Link href={url} passHref>
            <NextWrapper className={props.className} disabled={false}>
              次<FaAngleRight />
            </NextWrapper>
          </Link>
        );
      case 'prev':
        return isDisabled ? (
          <NextWrapper className={props.className} disabled={true}>
            <FaAngleLeft /> 前
          </NextWrapper>
        ) : (
          <Link href={url} passHref>
            <NextWrapper className={props.className} disabled={false}>
              <FaAngleLeft /> 前
            </NextWrapper>
          </Link>
        );
      case 'number':
        return props.status == 'active' ? (
          <Link href={url}>
            <NumberWrapper status={props.status} size={props.size}>
              {props.number}
            </NumberWrapper>
          </Link>
        ) : (
          <NumberWrapper status={props.status} size={props.size}>
            {props.number}
          </NumberWrapper>
        );
      case 'left':
        return props.status == 'active' ? (
          <Link href={url}>
            <ArrowWrapper size={props.size} status={props.status}>
              <FaAngleLeft></FaAngleLeft>
            </ArrowWrapper>
          </Link>
        ) : (
          <ArrowWrapper size={props.size} status={props.status}>
            <FaAngleLeft></FaAngleLeft>
          </ArrowWrapper>
        );
      case 'right':
        return props.status == 'active' ? (
          <Link href={url}>
            <ArrowWrapper size={props.size} status={props.status}>
              <FaAngleRight></FaAngleRight>
            </ArrowWrapper>
          </Link>
        ) : (
          <ArrowWrapper size={props.size} status={props.status}>
            <FaAngleRight></FaAngleRight>
          </ArrowWrapper>
        );
      default:
        return null;
    }
  }

  return getButton();
}
const ArrowWrapper = styled.div<{
  size?: 'large' | 'small';
  status?: 'active' | 'disabled' | 'normal';
}>`
  cursor: ${({ status }) => (status == 'active' ? 'pointer' : 'default')};
  svg {
    height: ${({ size }) => (size == 'large' ? '32px' : '20px')};
    width: ${({ size }) => (size == 'large' ? '16px' : '10px')};
    color: ${({ status }) =>
      status == 'disabled'
        ? 'var(--border-disabled, #949497)'
        : status == 'active'
        ? 'var(--color-gold, #bea66b)'
        : 'var(--color-dull-green, #b5c7c3)'};
  }
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    svg {
      color: ${({ status }) =>
        status == 'disabled'
          ? 'var(--border-disabled, #949497)'
          : 'var(--color-hover-gold, #dbcaa0)}'};
    }
  }
`;

const NumberWrapper = styled.div<{
  status?: 'active' | 'disabled' | 'normal';
  size?: 'large' | 'small';
}>`
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;

  width: ${({ size }) => (size == 'large' ? '40px' : '32px')};
  height: ${({ size }) => (size == 'large' ? '40px' : '32px')};

  cursor: ${({ status }) => (status == 'active' ? 'pointer' : 'default')};

  border: ${({ status, size }) =>
      status == 'disabled' ? '0px' : size == 'large' ? '2px' : '1px'}
    solid var(--color-gold, #bea66b);
  background: ${({ status }) =>
    status == 'disabled'
      ? '#0000'
      : status == 'active'
      ? 'var(--background-primary, #fff)'
      : 'var(--color-gold, #bea66b)'};
  color: ${({ status }) =>
    status == 'disabled'
      ? 'var(--tag-disabled, #8e8e8e)'
      : status == 'active'
      ? 'var(--color-gold, #bea66b)'
      : 'var(--background-primary, #fff)'};
  font-family: 'Noto Sans JP';
  font-size: ${({ size }) => (size == 'large' ? '1.5em' : '1em')};
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: 0.0125em;
  text-align: center;

  &:hover {
    background: var(--color-gold, #bea66b);
    color: var(--background-primary, #fff);
  }

  @media (max-width: ${BREAKPOINT_SP}) {
    width: 32px;
    height: 32px;
    border: ${({ status }) => (status == 'disabled' ? '0px' : '1px')} solid
      var(--color-gold, #bea66b);
    font-size: 1em;
    line-height: 1.5;
  }
`;

const NextWrapper = styled.div<{
  disabled: boolean; // disabled プロパティを追加
}>`
  display: flex;
  width: auto;
  height: 40px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  padding: 4px 12px;
  box-sizing: border-box;
  @media (max-width: ${BREAKPOINT_SP}) {
    height: 32px;
  }

  cursor: status = 'pointer';
  border: 1px solid var(--color-gold, #bea66b);
  background: var(--background-primary, #fff);
  color: var(--color-gold, #bea66b);

  font-family: 'Noto Sans JP';
  font-weight: 700;
  letter-spacing: 0.0125em;
  line-height: 1.5;
  text-align: center;

  // disabled 状態のスタイルを追加
  ${({ disabled }) =>
    disabled &&
    `
    background: var( --tag-disabled, #a1a1a1); 
    color: #ffff; 
    border: 1px solid transparent;
  `}
`;
